import { z } from 'zod'

export const DocTemplateDetailsSchema = z.object({
  historyPage: z.number().int().nonnegative().optional(),
  historySize: z.number().int().nonnegative().optional()
})
